import {
  Component,
  OnInit,
  TemplateRef,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { GetAuctionStep1 } from '../../../../models';
import { Observable, Subscription } from 'rxjs';
import constants from '../../../../utility/constants';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService, LotService, AddLotModel } from '../../../../services';
import { ToastrService } from 'ngx-toastr';
import { ExportToCsv } from 'export-to-csv';
import messages from '../../../../utility/messages';
import {
  AuctionImageUploadService,
  ImageFile,
} from '../../../../services/auction-image-upload.service';
import { FormControl } from '@angular/forms';
import { ImageValidators } from '../../../../core/validators/image-validators';
import { AuctionTimeService } from '../../../../services/auction-time.service';

@Component({
  selector: 'lot-listing',
  templateUrl: './lot-listing.component.html',
  styleUrls: ['./lot-listing.component.css'],
})
export class LotListingComponent implements OnInit {
  @Input() isAdminViewLot: boolean = false;
  @Input() auctionId: number;
  @Input() auctionData: GetAuctionStep1;
  @Output('goToStep') emitStep = new EventEmitter<number>();
  @Output('cancel') onCancelClick = new EventEmitter<boolean>();
  modalRef: BsModalRef;

  // both needs for add/edit lotForm
  lotAddEditActiveStep: number = 1;
  isIndividualLot: boolean = true;
  bidMaxAmount: number = constants.common.bid.bidMaxAmount;
  currentStep: number = 3;
  stepActive = 1;
  errorLogs: Array<string> = [];

  displayedColumns: string[] = [
    'lotNo',
    'lotDescription',
    'location',
    'startingPrice',
    'reservePrice',
    'lotEndTime',
    'currentBid',
    'lotButtons',
    'isFeatured',
    'lotAction',
  ];
  displayedColumns2: string[] = ['lotNo', 'lotDes', 'lotLocation', 'lotAction'];
  displayedColumns3: string[] = ['lotNo', 'lotDes', 'lotLocation', 'lotAction'];

  selectedLotData: any;

  // for pagination
  pageNumber: number = 1;
  pageSize: number = 50;
  searchTerm: string = '';
  isPaginated: boolean = true;

  showView: boolean = false;
  totalLots: number;
  lotsData: any;
  lotDeletedMessage: any;
  lotNumber: any;
  lotId: any;

  publishLoading: boolean = false;
  submitting: boolean = false;
  loading: boolean = false;

  // IMP for selected lot operations
  currentSelectedLot: any;

  // for manupulations on opening and reserve prices
  openingAndReservePriceArray: Array<{
    id: number;
    lotType: number;
    openingPrice: string;
    reservePrice: string;
  }> = [];

  // bulk lot related variables
  allBulkLots: Array<any> = [];
  allLotsOfBulkLot: Array<any> = [];
  bulkLotToBeAddInLot: any;
  bulkLotToBeAddInLotSubmit: boolean = false;

  // lotform image upload variables and settingg
  readonly lotImageSize: string = constants.admin.uploadSetting.lotMaxSize;
  readonly lotImageFormat: string = constants.admin.uploadSetting.lotType;
  resultantLotImages: Array<ImageFile> = [];
  thumbnailImageString: string = null;
  private uploadedThumbnailImage: ImageFile = null;
  addEditLotImages: ImageFile[] = [];

  // going to remove the lot, variable stored in this
  removingLotInfo: any;
  removeLotModalRef: BsModalRef;

  // bulk lot present is boolean
  isBulkLotPresent: boolean = false;

  isAuctionClosing: boolean;
  private subscriptions: Array<Subscription> = [];
  constructor(
    private lotService: LotService,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private auctionImageUploader: AuctionImageUploadService,
    private loaderService: LoaderService,
    private router: Router,
    private route: ActivatedRoute,
    private auctionTimeService: AuctionTimeService
  ) {}

  private createAddLotModel(lot: any): AddLotModel {
    let model: AddLotModel = {
      isUpdateAndPublish: true,
      auctionId: lot.auctionId,
      consignor: lot.consigner,
      category: lot.category,
      description: lot.description,
      location: lot.location,
      lotId: lot.id,
      lotNumber: lot.lotNumber,
      lotType: lot.lotType,
      openingPrice: lot.openingPrice,
      reservePrice: lot.reservePrice,
      quantity: lot.quantity,
      lotNumberAfterWhichThisWillBeAdded: lot.lotNumberAfterWhichThisWillBeAdded || 0,
    };
    return model;
  }

  ngOnInit(): void {
    this.route.fragment.subscribe((frag) => {
      if (frag) this.searchTerm = `#${frag}`;
    });

    this.isAuctionClosing = this.auctionTimeService.isLotClosingBegun(
      this.auctionData.endDateTimeUtc
    );

    this.getLots();
  }

  changeSearchValue(val: Observable<string>) {
    const vals = val.subscribe((value) => {
      this.searchTerm = value;
      this.pageNumber = 1;
      this.getLots();
    });
    this.subscriptions.push(vals);
  }

  switchModes(event) {
    this.isIndividualLot = event.target.value == 'true';
  }

  openAddLotModal(template: TemplateRef<any>) {
    this.currentSelectedLot = null;
    let modalOptions: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
      class:
        'custom-popup form-modal add-new-lots modal-dialog modal-dialog-centered',
    };
    this.modalRef = this.modalService.show(template, modalOptions);
  }

  closeModal() {
    if (this.modalRef) {
      this.modalRef.hide();
      this.currentSelectedLot = null;
      this.lotAddEditActiveStep = 1;
      this.loading = false;
      this.bulkLotToBeAddInLotSubmit = false;
      this.thumbnailImageString = null;
      this.uploadedThumbnailImage = null;
      this.bulkLotToBeAddInLot = null;
      this.addEditLotImages = [];
      this.thumbnailImageControl.reset();
      this.resultantLotImages = [];
      this.errorLogs = [];
      this.getLots();
    }
  }

  /////// prices change
  changePrices(lot: any, price: string, isReserve: boolean = false) {
    let checkPrice: number = price === '' ? null : +price;
    let lotId: number = lot.id;

    if (isReserve && lot.reservePrice === checkPrice) return;

    if (!isReserve && lot.openingPrice === checkPrice) return;

    let findedElementIndex = this.openingAndReservePriceArray.findIndex(
      (i) => i.id == lotId
    );

    if (findedElementIndex > -1) {
      let existedElement = this.openingAndReservePriceArray[findedElementIndex];

      this.openingAndReservePriceArray.splice(findedElementIndex, 1, {
        id: lotId,
        lotType: lot.lotType,
        openingPrice: isReserve ? existedElement.openingPrice : price,
        reservePrice: isReserve ? price : existedElement.reservePrice,
      });
    } else {
      let opening = lot.openingPrice == null ? '' : '' + lot.openingPrice;
      let reserve = lot.reservePrice == null ? '' : '' + lot.reservePrice;
      this.openingAndReservePriceArray.push({
        id: lotId,
        lotType: lot.lotType,
        openingPrice: isReserve ? opening : price,
        reservePrice: isReserve ? price : reserve,
      });
    }
  }

  savePrices() {
    if (this.openingAndReservePriceArray.length === 0) return;

    this.loaderService.showLoader(true);
    const mchanges = this.lotService
      .multiplePriceChange(this.auctionId, this.openingAndReservePriceArray)
      .subscribe(
        (res) => {
          this.loaderService.showLoader(false);
          this.openingAndReservePriceArray = [];
          if (res) {
            this.toastr.success('saved Successfully');
            this.getLots();
          }
        },
        () => {
          this.loaderService.showLoader(false);
          this.openingAndReservePriceArray = [];
          this.getLots();
        }
      );
    this.subscriptions.push(mchanges);
  }

  // paging change + lot listing
  paging() {
    let model = {
      auctionId: this.auctionId,
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      isPaginated: this.isPaginated,
      searchTerm: this.searchTerm,
    };
    return model;
  }

  // get lot listing
  getLots() {
    this.checkBulkLotPresent();

    if (this.searchTerm == null) {
      this.searchTerm = '';
    }
    this.showView = false;
    this.loaderService.showLoader(true);
    const aucLots = this.lotService.getAuctionLot(this.paging()).subscribe(
      (response: any) => {
        this.lotsData = response.data;
        this.totalLots = response.totalCount;
        this.showView = true;
        this.loaderService.showLoader(false);
      },
      (err) => {
        this.totalLots = 0;
        this.loaderService.showLoader(false);
      }
    );
    this.subscriptions.push(aucLots);
  }

  onPageChange(page: number) {
    this.pageNumber = page;
    this.getLots();
  }

  // download csv
  downloadCSV() {
    const dcsv = this.lotService
      .downloadCSV(this.auctionId)
      .subscribe((res: any) => {
        const options = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          showTitle: true,
          title: 'Lot Catalog',
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true,
        };

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(res);
      });
    this.subscriptions.push(dcsv);
  }

  addUpdateLot(lot) {
    let isPublishLot = true;
    this.submitting = true;

    this.submitting = false;
    if (isPublishLot) this.publishLoading = true;
    else this.loading = true;

    const clots = this.lotService
      .addUpdateLot(this.createAddLotModel(lot))
      .subscribe(
        (res: any) => {
          if (isPublishLot) this.publishLoading = false;
          else this.loading = false;
        },
        (err) => {
          if (isPublishLot) this.publishLoading = false;
          else this.loading = false;
          this.toastr.error(err, 'Error');
        }
      );
      this.subscriptions.push(clots);
  }


  publishLots() {
    this.loaderService.showLoader(true);
    let model = {
      auctionId: this.auctionId,
    };
    this.lotsData.forEach(lot => {
      if (!lot.openingPrice || lot.openingPrice === 0 || !lot.reservePrice || lot.reservePrice === 0) {
        if (lot.openingPrice === null || lot.openingPrice === 0) {
          lot.openingPrice = 1;
        }
        if (lot.reservePrice === null || lot.reservePrice === 0) {
          lot.reservePrice = 1;
        }
        this.addUpdateLot(lot);
      }
    })
    const plots = this.lotService.publishLots(model).subscribe(
      (res: any) => {
        this.toastr.success(
          'Lot Catalog published successfully',
          constants.common.toast.successTitle,
          constants.common.toast.config
        );
        this.loaderService.showLoader(false);
        this.router.navigateByUrl('/admin/dashboard/auction');
      },
      (error) => {
        this.loaderService.showLoader(false);
        this.toastr.error(
          error,
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
      }
    );
    this.subscriptions.push(plots);
  }

  // add/edit lot modal but not in use for now
  AddManageLotsModal(AddManageLots?: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      AddManageLots,
      Object.assign(
        {},
        {
          class:
            'custom-popup AddManageLotsModal form-modal modal-dialog modal-dialog-centered',
        }
      )
    );
  }

  // manage bulk lot
  manageBulkLotsModal(manageBulkLots: TemplateRef<any>, lotData: any) {
    this.currentSelectedLot = lotData;
    this.getLotsOfBulk();
    this.modalRef = this.modalService.show(manageBulkLots, {
      class:
        'custom-popup manageBulkLotsModal form-modal modal-dialog modal-dialog-centered',
    });
  }

  private getLotsOfBulk() {
    const blots = this.lotService
      .getLotsForBulkLot(this.currentSelectedLot.id)
      .subscribe(
        (res) => {
          this.allLotsOfBulkLot = res;
        },
        (err) => {
          this.toastr.error(err, 'Error');
          this.closeModal();
        }
      );
    this.subscriptions.push(blots);
  }

  // remove lots from bulk lot
  openRemoveLotModal(removeTemp: TemplateRef<any>, removeLotData: any) {
    this.removingLotInfo = removeLotData;
    this.removeLotModalRef = this.modalService.show(removeTemp, {
      class: 'modal-dialog modal-dialog-centered',
    });
  }

  removeLotFromBulkLot(lotData: any, isBulkLotList: boolean = false) {
    this.loaderService.showLoader(true);
    const rlots = this.lotService.removeLotFromBulk(lotData.id).subscribe(
      (res) => {
        this.loaderService.showLoader(false);
        if (res) {
          if (this.removeLotModalRef) this.removeLotModalRef.hide();
          if (isBulkLotList) {
            this.getLotsOfBulk();
          } else {
            this.toastr.success(
              `Lot Remove from Bulk Lot #${lotData.addedInBulkLotName} Successfully`,
              'Success'
            );
            lotData.addedInBulkLotId = 0;
            lotData.addedInBulkLotName = '';
          }
          this.removingLotInfo = null;
        }
      },
      (err) => {
        this.toastr.error(err, 'Error');
        this.loaderService.showLoader(false);
        if (this.removeLotModalRef) this.removeLotModalRef.hide();
      }
    );
    this.subscriptions.push(rlots);
  }

  // add lot to existing bulk lot modal
  addLotsExistingBulkModal(
    addLotsExistingBulk: TemplateRef<any>,
    lotData: any
  ) {
    this.currentSelectedLot = lotData;

    const bulklots = this.lotService
      .getAllBulkLots(this.auctionId)
      .subscribe((res) => {
        this.allBulkLots = res;
        this.modalRef = this.modalService.show(addLotsExistingBulk, {
          class:
            'custom-popup manageBulkLotsModal form-modal modal-dialog modal-dialog-centered',
        });
      });
    this.subscriptions.push(bulklots);
  }

  addBulkLotToLot() {
    this.bulkLotToBeAddInLotSubmit = true;
    if (!this.bulkLotToBeAddInLot) return;
    this.bulkLotToBeAddInLotSubmit = false;
    this.loaderService.showLoader(true);
    const addLots = this.lotService
      .addLotToBulkLot(this.currentSelectedLot.id, this.bulkLotToBeAddInLot.id)
      .subscribe(
        (res) => {
          this.loaderService.showLoader(false);
          if (res) {
            this.toastr.success(
              `Lot #${this.currentSelectedLot.lotNumber} Added in Bulk Lot#${this.bulkLotToBeAddInLot.lotNumber} Successfully`,
              'Success'
            );
            this.currentSelectedLot.addedInBulkLotId =
              this.bulkLotToBeAddInLot.id;
            this.currentSelectedLot.addedInBulkLotName =
              this.bulkLotToBeAddInLot.lotNumber;
            this.closeModal();
          }
        },
        (err) => {
          this.toastr.error(err, 'Error');
          this.loaderService.showLoader(false);
          this.closeModal();
        }
      );
    this.subscriptions.push(addLots);
  }

  // lot pause resume
  openPauseResumeModal(template3: TemplateRef<any>, currentLot) {
    this.selectedLotData = currentLot;
    let modalOptions: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
      class:
        'custom-popup form-modal add-new-lots modal-dialog modal-dialog-centered',
    };
    this.modalRef = this.modalService.show(template3, modalOptions);
  }

  pauseResumeBidding() {
    this.loaderService.showLoader(true);
    const pauseBidding = this.lotService
      .pauseResumeBidding(this.selectedLotData.id)
      .subscribe(
        (res) => {
          this.toastr.success(
            `Bidding on lot #${this.selectedLotData.lotNumber} ${
              this.selectedLotData.isBiddingPaused ? 'resumed' : 'paused'
            } successfully`,
            constants.common.toast.successTitle,
            constants.common.toast.config
          );
          this.selectedLotData.isBiddingPaused =
            !this.selectedLotData.isBiddingPaused;
          this.loaderService.showLoader(false);
          this.closeModal();
        },
        (err) => {
          this.toastr.error(
            err,
            constants.common.toast.errorTitle,
            constants.common.toast.config
          );
          this.loaderService.showLoader(false);
          this.closeModal();
        }
      );
    this.subscriptions.push(pauseBidding);
  }

  // lot mark as featured
  markLotAsFeatured(lot: any) {
    const mlots = this.lotService.markLotFeatured(lot.id).subscribe((res) => {
      if (res) {
        lot.isFeatured = !lot.isFeatured;
        this.toastr.success(
          `Lot #${lot.lotNumber} ${
            lot.isFeatured ? 'Marked' : 'Unmarked'
          } as Featured Successfully`
        );
      }
    });
    this.subscriptions.push(mlots);
  }

  // cancel button
  onCancel() {
    this.onCancelClick.emit(true);
  }

  // open modal
  openModal(template: TemplateRef<any>, lotData: any) {
    if (this.auctionData.auctionStatus == 1) {
      this.lotDeletedMessage =
        'You are deleting a lot that may have bids in place. Deleting the lot will also delete any existing bids on the lot. Are you sure you want to delete this lot?';
    } else {
      this.lotDeletedMessage = 'Are you sure you want to delete this lot?';
    }
    this.modalRef = this.modalService.show(
      template,
      Object.assign(
        {},
        {
          class: 'custom-popup delete-modal modal-dialog modal-dialog-centered',
        }
      )
    );
    this.lotNumber = lotData.lotNumber;
    this.lotId = lotData.id;
  }

  // open lot
  openLotModal(template3: TemplateRef<any>, lotData: any) {
    this.currentSelectedLot = lotData;
    this.isIndividualLot = this.currentSelectedLot.lotType == 1;
    let modalOptions: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
      class:
        'custom-popup form-modal add-new-lots modal-dialog modal-dialog-centered',
    };
    this.modalRef = this.modalService.show(template3, modalOptions);
    this.findThumbnailImage();
  }

  // go to step back
  goToStep(isBack: boolean = false) {
    this.emitStep.emit(!isBack ? this.currentStep + 1 : this.currentStep - 1);
  }

  // delete lot
  onDelete(id: number) {
    this.loaderService.showLoader(true);
    const dlots = this.lotService.deleteLot(id).subscribe(
      () => {
        this.toastr.success(
          messages.lot.deleted,
          constants.common.toast.successTitle,
          constants.common.toast.config
        );
        this.closeModal();
        this.loaderService.showLoader(false);
      },
      (err) => {
        this.toastr.error(
          err,
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
        this.closeModal();
        this.loaderService.showLoader(false);
      }
    );
    this.subscriptions.push(dlots);
  }

  //// lot add/edit, step1 operations
  // thumbnailImageControl
  thumbnailImageControl = new FormControl(null, [
    ImageValidators.sizeCheck(this.lotImageSize),
    ImageValidators.imageFormat(this.lotImageFormat),
  ]);

  // switch steps
  switchLotAddEditSteps(stepNum: number) {
    this.lotAddEditActiveStep = stepNum;
    this.findThumbnailImage();
    this.errorLogs = [];
    this.resultantLotImages = [];
    let file = this.getThumbnailImage();
    if (file && typeof file?.name !== 'string') {
      this.thumbnailImageControl.reset();
      this.thumbnailImageString = null;
    }
  }

  // when step1 of lotForm completed
  lotFormStepCompleted(newlyAddedLotData: any) {
    this.addEditFormDone();
    this.currentSelectedLot = newlyAddedLotData;
    this.switchLotAddEditSteps(2);
  }

  //// lot image upload, step2 operations
  // identify thumbnail image

  findThumbnailImage() {
    if (this.currentSelectedLot?.images?.length) {
      if (this.currentSelectedLot?.images[0]) {
        this.uploadedThumbnailImage = this.currentSelectedLot?.images[0];
        this.thumbnailImageString =
          this.currentSelectedLot?.images[0].name + '?' + this.newGuid();
        this.addEditLotImages = this.currentSelectedLot?.images.slice(
          1,
          this.currentSelectedLot?.images.length
        );
      } else {
        this.addEditLotImages = this.currentSelectedLot?.images;
      }
    }
  }
  private newGuid() {
    return new Date().getTime();
  }

  getThumbnailImage(): ImageFile {
    let file = this.thumbnailImageControl.value;
    if (this.uploadedThumbnailImage && file)
      return { id: this.uploadedThumbnailImage.id, name: file, order: 1 };
    return file ? { id: 0, name: file, order: 1 } : null;
  }

  // add thumbnail image
  uploadThumbnailImage(files: FileList) {
    let reader = new FileReader();
    this.thumbnailImageString = null;
    let control = this.thumbnailImageControl;
    if (files.length > 0) {
      control.setValue(files[0]);
      control.markAsTouched();
      control.updateValueAndValidity();
      if (control.valid) {
        reader.readAsDataURL(files[0]);
        reader.onload = () => {
          this.thumbnailImageString = reader.result as string;
        };
      } else {
        this.thumbnailImageString = null;
        control.markAsTouched();
      }
    }
  }

  // when click on step2 save button, images got upload and close modal
  async addEditLotStep2Submit() {
    this.errorLogs = [];
    if (
      !this.thumbnailImageControl.value &&
      this.resultantLotImages.length == 0
    ) {
      this.closeModal();
      return;
    }

    let thumbnail = this.getThumbnailImage();
    let failedImages = [];
    this.loading = true;

    if (thumbnail) {
      try {
        await this.auctionImageUploader
          .uploadLotImage(
            this.currentSelectedLot.id,
            thumbnail.id,
            thumbnail.name,
            thumbnail.order
          )
          .toPromise();
      } catch (err) {
        let fileName =
          typeof thumbnail.name === 'string'
            ? thumbnail.name
            : thumbnail.name?.name;
        this.errorLogs.push(`issue for image ${fileName} : ${err}`);
        failedImages.push(err);
      }
    }

    if (this.resultantLotImages.length) {
      for (let processNum = 1; processNum <= this.resultantLotImages.length; ) {
        let fileProcess = this.resultantLotImages[processNum - 1];
        try {
          await this.auctionImageUploader
            .uploadLotImage(
              this.currentSelectedLot.id,
              fileProcess.id,
              fileProcess.name,
              fileProcess.order + 1
            )
            .toPromise();
        } catch (err) {
          processNum++;
          let fileName =
            typeof fileProcess.name === 'string'
              ? fileProcess.name
              : fileProcess.name.name;
          this.errorLogs.push(`issue for image ${fileName} : ${err}`);
          failedImages.push(err);
          continue;
        }
        processNum++;
      }
      if (failedImages && failedImages.length > 0) {
        this.toastr.error(
          'Error(s) occured while uploading images, please see logs',
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
      }
    }
    this.loading = false;
    if (this.errorLogs && this.errorLogs.length === 0) {
      this.addEditFormDone();
      this.closeModal();
    }
  }

  private addEditFormDone() {
    this.toastr.success(
      `${this.isIndividualLot ? 'Piecemeal' : 'Bulk'} Lot ${
        this.currentSelectedLot ? 'Updated' : 'Added'
      } Successfully`,
      'Success'
    );
  }

  //// check bulk lot present in it or not
  private checkBulkLotPresent() {
    this.isBulkLotPresent = false;
    const lotpresent = this.lotService
      .isAnyBulkLotPresent(this.auctionId)
      .subscribe((res) => (this.isBulkLotPresent = res));
    this.subscriptions.push(lotpresent);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
